<template>
  <div class="user-wrap">
    <div class="left">
      <img src="./linkredit LOGO.png" alt="" srcset="" />
    </div>
    <form ref="formRef" :action="Url" method="post">
      <input type="hidden" name="SAMLRequest" :value="samlRequest" />
    </form>
    <el-dialog
      title="Select Source"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-select style="width: 100%" v-model="isSelectSource">
        <el-option
          v-for="item in sourceList"
          :label="item.label"
          :value="item.value"
          :key="item.value"
        />
      </el-select>
      <div slot="footer">
        <customize-button type="primary" @click="handleContinueLogin">
          Continue
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMenu, routerAdfs } from './api'
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      Url: '',
      samlRequest: '',
      dialogVisible: false,
      value: '',
      token: '',
      source: '',
      userName: '',
      platform: '',
      menus: [],
      isSelectSource: '',
      sourceList: [
        {
          value: '1',
          label: 'Trade',
        },
        {
          value: '2',
          label: 'CSS',
        },
      ],
    }
  },
  mounted() {
    this.getMenu()
  },
  methods: {
    ...mapMutations([
      'setMenus',
      'setUsername',
      'setToken',
      'setSource',
      'setItcode',
      'setBtnPermissionList',
    ]),
    async getMenu() {
      const res = await getMenu({
        username: this.$route.query.username || '',
        token: this.$route.query.token || '',
      })
      if (res.status === false) {
        const res = await routerAdfs()
        this.Url = res.ssoUri
        this.samlRequest = res.samlRequest
        if (this.Url) {
          window.open(
            `https://stscn.lenovo.com/adfs/ls/IdpInitiatedSignOn.aspx?loginToRp=${res.issureValue}`,
            '_self',
          )
        }
      } else {
        try {
          if (res.token.indexOf('Bearer') !== -1) {
            this.token = res.token
          } else {
            this.token = 'Bearer ' + res.token
          }
          this.source = res.source
          this.userName = res.name
          this.menus = res.menus
          this.platform = res.platform
          this.btn = res.btn
          // 该itCode账号下只有CSS或Trade,直接进入首页
          if (this.platform !== 3) {
            this.setToken(this.token)
            this.setSource(this.source)
            this.setUsername(this.userName)
            this.setMenus(this.menus)
            this.setBtnPermissionList(this.btn)
            await this.$router.push('/dashboard')
          } else {
            this.dialogVisible = true
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    handleContinueLogin() {
      if (!this.isSelectSource) {
        this.$message.warning('Please Select Source!')
        return
      }
      if (this.source === 2) {
        if (this.isSelectSource === '1') {
          this.$router.push('/user/login')
        } else {
          this.setToken(this.token)
          this.setSource(this.source)
          this.setUsername(this.userName)
          this.setMenus(this.menus)
          this.setBtnPermissionList(this.btn)
          this.$router.push('/dashboard')
        }
      } else {
        if (this.isSelectSource === '2') {
          this.$router.push('/user/login')
        } else {
          this.setToken(this.token)
          this.setSource(this.source)
          this.setUsername(this.userName)
          this.setMenus(this.menus)
          this.setBtnPermissionList(this.btn)
          this.$router.push('/dashboard')
        }
      }
      this.dialogVisible = false
    },
  },
}
</script>

<style lang="scss">
.user-wrap {
  display: flex;
  width: 100%;
  height: 100%;

  .left {
    width: 100%;
    background: url('./background.png') no-repeat;
    background-size: cover;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin: 105px 40px;
    }
    span {
      display: block;
      padding-top: 48px;
      font-size: 18px;
      font-weight: 400;
      margin-left: 46px;
    }
  }
  .right {
    flex: 1;
    width: 100%;
    overflow-y: auto;

    .right-content {
      width: 650px;
      margin: 125px auto 0;
    }

    .user-input {
      height: 54px;
    }

    .user-label {
      font-size: 16px;
      color: #3a3f63;
      line-height: 24px;
      font-weight: 400;
    }

    .submit-btn {
      width: 240px;
      font-family: Rubik-Regular;
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>
